import { render, staticRenderFns } from "./Mailverlauf.vue?vue&type=template&id=a54343f0"
import script from "./Mailverlauf.vue?vue&type=script&lang=js"
export * from "./Mailverlauf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a54343f0')) {
      api.createRecord('a54343f0', component.options)
    } else {
      api.reload('a54343f0', component.options)
    }
    module.hot.accept("./Mailverlauf.vue?vue&type=template&id=a54343f0", function () {
      api.rerender('a54343f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Mailverlauf.vue"
export default component.exports